const lozad = require('lozad');
export default  ()=>{
    const observer = lozad();
    observer.observe();
}


